export const defaultActiveuserApiParams = {
  page: 1,
  // page_size: 100,
  page_size: 50,
  entity_type: 'mobile',
  data_method: '',
  region_type: 'region',
  regions: ['global'],
  date_type: 'daily',
  start_date: '',
  end_date: '',
  genre_source: 'iegg',
  iegg_genre_req: [],
  company: [],
  start_release_time: '',
  end_release_time: '',
  game_code: [], // 用于在折线图里请求折线图数据，同时表格接口里用于搜索
  search_by_name: '',
  segment: 'all',
  unified_ids: [], // 已弃用
  chart_type: 0, // 用于榜单游戏继承，请求折线图接口获取可视化
  sensortower_tag_filter: [],
  filter_ids: [],
};
